import { render, staticRenderFns } from "./CompareDialog.vue?vue&type=template&id=36df2c8d"
import script from "./CompareDialog.vue?vue&type=script&lang=js"
export * from "./CompareDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports